module.exports = __webpack_public_path__ + "static/media/sell_start_service_teach_1.4649dc9f.jpg";